var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showAlert)?_c('alert',{staticClass:"mt-4 mx-3 mb-0 w-100",attrs:{"cols":12}},[_vm._v(" You can only have up to "+_vm._s(_vm.maxFacilities)+" facilities. No additional facilities can be added. ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }